import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import "../css/styles.scss";
import { enable, disable, isEnabled } from "cursor-flashlight";
import flashlightOnImage from "../images/flashlight-on.png";
import flashlightOffImage from "../images/flashlight-off.png";
import useSound from "use-sound";
import spaceMusic from "../music/spacemusic.mp3";
import musicOnImage from "../images/headphone-fill.png";
import musicOffImage from "../images/headphone-line.png";
import switchOn from "../sounds/switchon.mp3";
import css from "../css/homePage.css";
import "../css/homePage.scss";

function Header() {
  //music
  const audioRef = useRef(new Audio("spacemusic.mp3"));

  const [isPlay, setPlay] = useState(false);

  function handleAudio() {
    new Audio(audioRef);
    if (!isPlay) {
      setPlay(true);
      audioRef.current.play();
      disable();
    } else {
      setPlay(false);
      audioRef.current.pause();
    }
  }
  //flashlight
  const [isFlashlightEnabled, setIsFlashlightEnabled] = useState(isEnabled());

  function handleToggleFlashlight() {
    if (isEnabled()) {
      disable();
      setIsFlashlightEnabled(false);
      //play turn off sound
      new Audio("sounds/switchoff.mp3").play();
      console.log(`test`);
    } else {
      enable({ size: "5vmax" });
      setIsFlashlightEnabled(true);
      //play turn on sound
      new Audio("sounds/switchon.mp3").play();
      console.log(`test2`);
    }
  }

  const background = isFlashlightEnabled;

  return (
    <div>
      <div className="hamburger-menu">
        <div class="menu-body">
          <nav role="navigation">
            <div id="menuToggle">
              <input type="checkbox" />

              <span></span>
              <span></span>
              <span></span>

              <ul id="menu">
                <Link className="router-link" to="/home">
                  Home Page
                </Link>

                <Link className="router-link" to="/basics">
                  Basics
                </Link>

                <Link className="router-link" to="/flexbox">
                  Flexbox
                </Link>

                <Link className="router-link" to="/cssgrid">
                  CSS Grid
                </Link>

                <Link className="router-link" to="/styling">
                  Advanced Styling
                </Link>

                <Link className="router-link" to="/pseudoclasses">
                  Pseudo-classes
                </Link>

                <Link className="router-link" to="/pseudoselectors">
                  Pseudo-selectors
                </Link>

                <Link className="router-link" to="/pseudoelements">
                  Pseudo-elements
                </Link>

                <Link className="router-link" to="/mobile">
                  Resizing with @media
                </Link>

                <Link className="router-link" to="/animation">
                  CSS Animation
                </Link>

                <Link className="router-link" to="/quicktips">
                  Quick Tips
                </Link>

                <Link className="router-link" to="/examples">
                  Examples
                </Link>
              </ul>
            </div>
          </nav>
        </div>
      </div>

      <div className="header-div">
        <header>
          <Link className="router-link" to="/home">
            Home
          </Link>

          <Link className="router-link" to="/basics">
            Basics
          </Link>

          <Link className="router-link" to="/flexbox">
            Flexbox
          </Link>

          <Link className="router-link" to="/cssgrid">
            Grid
          </Link>

          <Link className="router-link" to="/styling">
            Advanced
          </Link>

          <Link className="router-link" to="/pseudoclasses">
            Pseudo-classes
          </Link>

          <Link className="router-link" to="/pseudoelements">
            Pseudo-elements
          </Link>

          <Link className="router-link" to="/pseudoselectors">
            Pseudo-selectors
          </Link>

          <Link className="router-link" to="/mobile">
            Resize with @media
          </Link>

          <Link className="router-link" to="/animation">
            Animation
          </Link>

          <Link className="router-link" to="/quicktips">
            Quick Tips
          </Link>

          <Link className="router-link" to="/examples">
            Examples
          </Link>
        </header>

        {/* flashlight */}
        <div className="flashlight-cursor">
          <div className="flashlight-content">
            <img
              //change the image based on whether the state is true or not
              src={isFlashlightEnabled ? flashlightOnImage : flashlightOffImage}
              className="flashlight-button-on"
              onClick={handleToggleFlashlight}
            ></img>
          </div>
        </div>
        {/* flashlight end  */}

        {/* MUSIC BUTTON */}
        <div className="music-button">
          <img
            onClick={handleAudio}
            //change the image based on whether the state is true or not
            src={isPlay ? musicOnImage : musicOffImage}
          ></img>
        </div>
        {/* Music BUTTON END */}
      </div>
    </div>
  );
}

export default Header;
